/* eslint-disable */
import React from "react";
import styled from "styled-components";

function Footer() {
  return (
    <Container>
      <TitleBox>
        <Title>(주)어텀팔콘스</Title>
        <Subtitle>사업자 등록번호: 282-88-02253 | 김준석</Subtitle>
        <Subtitle>support@autumnfalcons.com</Subtitle>
        <Subtitle>
          서울시 양천구 목동동로 309 14층 7호 (서울청년창업사관학교)
        </Subtitle>
        {/* <Subtitle>연락처: 054-274-1062</Subtitle> */}

        {/* <InfoDiv>
        <Subtitle>개인정보이용약관</Subtitle>
        <Subtitle>약도보기</Subtitle>
      </InfoDiv> */}
      </TitleBox>
    </Container>
  );
}
export default Footer;

const Container = styled.footer`
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: flex-start;
  padding: 100px 0;
  background-color: #181d24;
  color: white;
`;
const TitleBox = styled.div`
  width: auto;
  margin-left: 54px;
  @media screen and (max-width: 470px) {
    margin-left: 25px;
  }
`;
const Title = styled.p`
  font-size: 20px;
  font-weight: 600;
  margin: 0px 0 30px 0px;
`;
const Subtitle = styled.p`
  font-size: 12px;
  font-weight: 300;
  margin: 0px 0 10px 0px;
  @media screen and (max-width: 470px) {
    font-size: 10px;
  }
`;

const InfoDiv = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 30px;
`;
